import React, {Fragment} from "react";
import PropTypes from "prop-types";
import SecurityQuestionsInputComponent from "../input/SecurityQuestionsInputComponent";
import {setupOnExtractData} from "../../../util/FormUtil";

class SecurityQuestionsComponent extends React.Component {
    constructor(props){
        super(props);
        this.state = {};
        this.setExtractData = this.setExtractData.bind(this);
    }

    componentDidMount() {
        setupOnExtractData(this);
    }

    setExtractData(extractDataFunction){
        this.extractData = extractDataFunction;
    }

    render(){
        const {data, metadata, setFormState, userDataInit, required=true} = this.props;
        const {hideMe} = this.state;
        if (hideMe){
            return "";
        }
        return (
            <div className="grid">
                <div className="grid__col-md-3 grid__col-sm-12">
                    Security Questions<br />
                    <p className="paragraph--small">Please do not disclose any personal identification information in the security questions (i.e. age, gender, religion, etc.).</p>
                </div>
                <div className="grid__col-md-9 grid__col-sm-12">
                    <SecurityQuestionsInputComponent
                        data={data}
                        metadata={metadata}
                        setFormState={setFormState}
                        userDataInit={userDataInit}
                        required={required}
                        onExtractData={this.setExtractData}
                    />
                </div>
            </div>
        );
    }
}

SecurityQuestionsComponent.propTypes = {
    data: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    required: PropTypes.bool,
    onExtractData: PropTypes.func
};

export default SecurityQuestionsComponent;